<div class="container d-flex justify-content-center">
    <img src="/assets/Assets/pbris_logo/PBRIS Logo Colored.png" height="120" alt="PBRIS">
</div>